<mat-toolbar class="toolbar" [ngStyle]="{backgroundColor: ('#' + color) || 'initial'}">

  <!-- Hamburger logo -->
  <button mat-flat-button color="primary" class="sidebar-btn" (click)="onHamburgerClicked.emit()">
    <mat-icon>menu</mat-icon>
  </button>

  <!-- Scotty Logo -->
  <a class="logo" [routerLink]="isExternal ? [] : ['/']">
    <img [src]="logo || settingsManagerService.getLogo(true)" [alt]="!isExternal ? 'Scotty Expert' : ''">
  </a>

  <!-- Username, company and download company QR -->
  <button *ngIf="environment.authProvider == 'parse'; else simpleCompanyName" mat-button class="company-name" (click)="downloadConfigurationQR()">
    <span>{{accountManagerService.account.displayName}}&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;{{accountManagerService.account?.company?.name}}</span>
    <mat-icon>qr_code</mat-icon>
  </button>
  <ng-template #simpleCompanyName>
    <span *ngIf="!hideCompanyInfo" class="company-name">{{accountManagerService.account.displayName}}&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;{{accountManagerService.account?.company?.name}}</span>
  </ng-template>

</mat-toolbar>
